/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UserSalutationType = "COMPANY" | "MR" | "MRS" | "NONE" | "%future added value";
export type UserTitleType = "DR" | "NONE" | "PROF" | "PROF_DR" | "%future added value";
export type RefreshTokenMutationVariables = {|
  accessToken: string,
  refreshToken: string,
|};
export type RefreshTokenMutationResponse = {|
  +info: {|
    +status: boolean,
    +Me: ?{|
      +id: string,
      +name: ?string,
      +firstname: ?string,
      +lastname: ?string,
      +salutation: UserSalutationType,
      +title: UserTitleType,
      +role: ?string,
      +email: ?string,
      +can: $ReadOnlyArray<?string>,
      +Companies: ?$ReadOnlyArray<?{|
        +id: string,
        +name: string,
      |}>,
    |},
    +accessToken: ?string,
    +refreshToken: ?string,
  |}
|};
export type RefreshTokenMutation = {|
  variables: RefreshTokenMutationVariables,
  response: RefreshTokenMutationResponse,
|};
*/


/*
mutation RefreshTokenMutation(
  $accessToken: String!
  $refreshToken: String!
) {
  info: refreshToken(accessToken: $accessToken, refreshToken: $refreshToken) {
    status
    Me {
      id
      name
      firstname
      lastname
      salutation
      title
      role
      email
      can
      Companies {
        id
        name
      }
    }
    accessToken
    refreshToken
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accessToken"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "refreshToken"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": "info",
    "args": [
      {
        "kind": "Variable",
        "name": "accessToken",
        "variableName": "accessToken"
      },
      {
        "kind": "Variable",
        "name": "refreshToken",
        "variableName": "refreshToken"
      }
    ],
    "concreteType": "Token",
    "kind": "LinkedField",
    "name": "refreshToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstname",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastname",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "salutation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "can",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CompanyInfo",
            "kind": "LinkedField",
            "name": "Companies",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accessToken",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refreshToken",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RefreshTokenMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RefreshTokenMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "0157749d1d1ad6d2a012e60b878ce337",
    "id": null,
    "metadata": {},
    "name": "RefreshTokenMutation",
    "operationKind": "mutation",
    "text": "mutation RefreshTokenMutation(\n  $accessToken: String!\n  $refreshToken: String!\n) {\n  info: refreshToken(accessToken: $accessToken, refreshToken: $refreshToken) {\n    status\n    Me {\n      id\n      name\n      firstname\n      lastname\n      salutation\n      title\n      role\n      email\n      can\n      Companies {\n        id\n        name\n      }\n    }\n    accessToken\n    refreshToken\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'affac5a91599ee5a9aab67a314654737';

module.exports = node;
